<template>
  <div class="portal-page">
    <smart-gas-background />
    <div class="portal-content">
      <h1 class="portal-title">智慧燃气综合管理平台</h1>
      <div class="portal-grid">
        <div
          v-for="item in systems"
          :key="item.key"
          class="portal-card"
          :class="{ active: item.active, locked: !item.active }"
          @click="onCardClick(item)"
        >
          <div class="card-body">
            <div class="icon-wrap">
              <i :class="item.icon"></i>
            </div>
            <div class="card-title">{{ item.title }}</div>
            <div v-if="!item.active" class="lock-wrap">
              <i class="el-icon-lock"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmartGasBackground from '@/components/SmartGasBackground.vue'
import { goAdminHome } from '@/router'

export default {
  name: 'PortalHome',
  components: { SmartGasBackground },
  data() {
    return {
      systems: [
        { key: 'meter', title: '燃气仪表数据采集系统', icon: 'el-icon-s-custom', active: true },
        { key: 'inspect', title: '智能巡检系统', icon: 'el-icon-aim', active: false },
        { key: 'safety', title: '入户安检系统', icon: 'el-icon-office-building', active: false },
        { key: 'gis', title: 'GIS信息系统', icon: 'el-icon-office-building', active: false },
        { key: 'regulator', title: '调压器预警分析系统', icon: 'el-icon-data-line', active: false },
        { key: 'om', title: '燃气设备运维管理系统', icon: 'el-icon-first-aid-kit', active: false },
        { key: 'flow', title: '流量计输差分析系统', icon: 'el-icon-user', active: false },
        { key: 'cp', title: '智能阴保系统', icon: 'el-icon-user', active: false }
      ]
    }
  },
  methods: {
    async onCardClick(item) {
      if (!item.active) {
        this.$message.info('该系统暂未开放')
        return
      }
      if (this.$store.state.token) {
        try {
          await goAdminHome()
        } catch (e) {
          this.$message.error('进入后台失败，请重新登录')
          this.$router.push('/login')
        }
      } else {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.portal-page {
  position: relative;
  min-height: 100vh;
  padding: 48px 24px 64px;
  box-sizing: border-box;
  overflow: hidden;
  background: #062451;
}

.portal-content {
  position: relative;
  z-index: 1;
}

.portal-title {
  margin: 0 0 48px;
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  color: #f5fffd;
  text-shadow: 0 8px 24px rgba(3, 28, 34, 0.28);
  letter-spacing: 0;
}

.portal-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 28px 32px;
}

.portal-card {
  background: rgba(255, 255, 255, 0.90);
  border-radius: 8px;
  min-height: 168px;
  padding: 32px 16px 28px;
  text-align: center;
  box-shadow: 0 16px 42px rgba(3, 28, 34, 0.18);
  border: 1px solid rgba(190, 245, 233, 0.26);
  backdrop-filter: blur(12px);
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
}

.card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.portal-card.active {
  cursor: pointer;
}

.portal-card.active:hover {
  transform: translateY(-4px);
  border-color: rgba(127, 247, 226, 0.52);
  box-shadow: 0 22px 56px rgba(3, 28, 34, 0.26);
}

.portal-card.locked {
  cursor: not-allowed;
  opacity: 0.92;
}

.icon-wrap {
  font-size: 56px;
  color: #1677ff;
  line-height: 1;
  margin-bottom: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1677ff;
  line-height: 1.5;
  padding: 0 8px;
}

.lock-wrap {
  margin-top: 14px;
  font-size: 18px;
  line-height: 1;
  color: #1d2129;
}

@media (max-width: 992px) {
  .portal-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 520px) {
  .portal-title {
    font-size: 26px;
  }
  .portal-grid {
    grid-template-columns: 1fr;
  }
}
</style>
